<template>
  <div>
    <!-- Start Header Area -->
    <Header>
      <img slot="logo" :src="logo" />
    </Header>
    <!-- End Header Area -->

    <!-- Start Breadcrump Area  -->
    <div
      class="rn-page-title-area pt--120 pb--190 bg_image bg_image--35"
      data-black-overlay="6"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="text-center rn-page-title pt--100">
              <h2 class="heading-title theme-gradient">Contact Us</h2>
              <p>
                Let's turn your ideas into reality - reach out and let's create something amazing together!
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <!-- Start Contact Address Area  -->
    <div class="rn-contact-top-area ptb--120 bg_color--5">
      <v-container>
        <div class="text-center section-title mb--30">
          <span class="subtitle">Our contact address</span>
          <h2 class="heading-title">Quick Contact Address</h2>
          <p class="description">
            Get in touch with us quickly and easily through any of
            <br />
            our convenient contact channels below.
          </p>
        </div>
        <ContactAddress />
      </v-container>
    </div>
    <!-- End Contact Address Area  -->

    <!-- Start Contact Area  -->
    <div class="rn-contact-page ptb--120 bg_color--1">
      <div class="contact-form--1">
        <v-container>
          <Contact>
            <img
              slot="contact-img"
              src="../assets/images/about/about-15.png"
              alt="contact images"
            />
          </Contact>
        </v-container>
      </div>
    </div>
    <!-- End Contact Area  -->

    <!-- Start Google MAp -->
    <div class="google-map rn-contact-map-area position-relative">
      <div class="mapouter">
        <div class="gmap_canvas">
          <iframe
            id="gmap_canvas"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4797.907200440033!2d121.05298847596737!3d14.515300385961027!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397cf4a87083341%3A0x48db78016e9621f3!2sBarangay%20North%20Signal!5e1!3m2!1sen!2sph!4v1746844338262!5m2!1sen!2sph"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
          ></iframe
          ><a href="https://embedgooglemap.net/maps/70"></a><br />
          <a href="https://www.embedgooglemap.net">google map code embed</a>
        </div>
      </div>
    </div>
    <!-- End Google MAp -->

    <!-- Start Brand Area -->
    <!-- <div class="rn-brand-area bg_color--5 ptb--120">
      <v-container>
        <Brand />
      </v-container>
    </div> -->
    <!-- End Brand Area -->
    <Footer />
  </div>
</template>

<script>
  import Header from "../components/header/Header";
  import ContactAddress from "../components/contact/ContactAddress";
  import Contact from "../components/contact/Contact";
  import Brand from "../components/brand/Brand";
  import Footer from "../components/footer/Footer";
  export default {
    components: { Header, ContactAddress, Contact, Brand, Footer },
    data() {
      return {
        logo: require("../assets/images/logo/logo-ko.png"),
      };
    },
  };
</script>

<style lang="scss">
  .mapouter {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .gmap_canvas {
    overflow: hidden;
    background: none !important;
    height: 800px;
    width: 100%;
    @media only screen and (max-width: 1199px) {
      height: 500px;
    }
    @media only screen and (max-width: 992px) {
      height: 420px;
    }
  }
  .gmap_canvas iframe {
    width: 100%;
    height: 100%;
  }
</style>
